import { render, staticRenderFns } from "./assign-modal.vue?vue&type=template&id=63f0bcfc&"
import script from "./assign-modal.vue?vue&type=script&lang=ts&"
export * from "./assign-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports